module.exports = __webpack_public_path__ + "media/daylight.0bb634bf.mp3";